import React, { useEffect, useState } from "react";
// MUI Components
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Skeleton,
  Box,
  IconButton,
  Chip,
} from "@mui/material";
// utils
import { hoteGames } from "../../../Utilities/dashboardSummary";
// MUI Icon
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

export const HotGames = () => {
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardsPerPage = 4;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await hoteGames();
        setResponseData(response?.top10Games);
      } catch (error) {
        console.error("Error fetching user engagement:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const visibleCards =
    responseData &&
    responseData?.slice(currentIndex, currentIndex + cardsPerPage);

  return (
    <React.Fragment>
      <Card
        variant="outlined"
        sx={{
          mt: 2,
          backgroundColor: "#242424",
          borderRadius: "8px",
          padding: "20px",
          position: "relative",
        }}
      >
        {/* Title and Buttons (Aligned to Right) */}
        <Box>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            mb={0}
            sx={{ fontSize: 22, fontWeight: 500, color: "#FFF" }}
          >
            Hot Games
          </Typography>
        </Box>

        {/* Navigation Buttons (Right Aligned) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{
              color: "#FFF",
            }}
            onClick={() =>
              setCurrentIndex((prev) => Math.max(prev - cardsPerPage, 0))
            }
            disabled={currentIndex === 0}
          >
            <ArrowCircleLeftIcon sx={{ fontSize: 25 }} />
          </IconButton>

          <IconButton
            sx={{
              color: "#FFF",
            }}
            onClick={() =>
              setCurrentIndex((prev) =>
                Math.min(
                  prev + cardsPerPage,
                  responseData.length - cardsPerPage
                )
              )
            }
            disabled={currentIndex + cardsPerPage >= responseData.length}
          >
            <ArrowCircleRightIcon sx={{ fontSize: 25 }} />
          </IconButton>
        </Box>

        {/* Cards Section */}
        <Grid container spacing={2}>
          {loading
            ? [...Array(4)].map((_, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    variant="outlined"
                    sx={{
                      mt: 1,
                      border: "1px solid #1A1A1A",
                      background: "#1A1A1A",
                    }}
                  >
                    <CardContent>
                      <Skeleton
                        width="60%"
                        height={20}
                        sx={{ mt: 1, background: "#fff" }}
                      />
                      <Skeleton
                        width="40%"
                        height={30}
                        sx={{ mt: 1, background: "#fff" }}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              ))
            : visibleCards?.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    variant="outlined"
                    sx={{
                      mt: 1,
                      border: "1px solid #1A1A1A",
                      background: "#1A1A1A",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                          mb: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#FFD700",
                          }}
                        >
                          {item?.gameName}
                        </Typography>
                        <Chip
                          variant="filled"
                          size="small"
                          color={item?.type === "VE" ? "primary" : "secondary"}
                          label={item?.type}
                        />
                      </Box>

                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: 24,
                          fontWeight: 400,
                          color: "#FFF",
                          mt: 2,
                        }}
                      >
                        {item?.count}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
        </Grid>
      </Card>
    </React.Fragment>
  );
};
